const RETURN_TO_KEY = "sunsure-return-to";

// Reads the `exp` claim (seconds since epoch) from a JWT, or null if the
// token isn't a decodable JWT.
export function getTokenExpiryMs(token) {
  try {
    const payload = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const { exp } = JSON.parse(atob(payload));
    return typeof exp === "number" ? exp * 1000 : null;
  } catch {
    return null;
  }
}

// Remembers where an expired session was so login can send the agent back.
// Stored in localStorage because logout clears sessionStorage.
export function saveReturnTo(userId) {
  try {
    const { pathname, search } = window.location;
    if (pathname === "/") return;
    window.localStorage.setItem(
      RETURN_TO_KEY,
      JSON.stringify({ userId, path: `${pathname}${search}` })
    );
  } catch {
    // Best-effort.
  }
}

export function clearReturnTo() {
  try {
    window.localStorage.removeItem(RETURN_TO_KEY);
  } catch {
    // Nothing to clear.
  }
}

// Returns the saved path only for the same agent who was signed out, and
// only for same-origin app paths.
export function consumeReturnTo(userId) {
  try {
    const saved = JSON.parse(window.localStorage.getItem(RETURN_TO_KEY));
    window.localStorage.removeItem(RETURN_TO_KEY);
    if (
      saved &&
      Number(saved.userId) === Number(userId) &&
      typeof saved.path === "string" &&
      saved.path.startsWith("/") &&
      !saved.path.startsWith("//")
    ) {
      return saved.path;
    }
  } catch {
    // Fall through to the default landing page.
  }
  return null;
}
